import {pxmModbusService} from "../services/pxm-modbus.service";
import {pxmModbusConstants} from "../constants/pxm-modbus.constants";
import {modalActions} from "./modal.actions";

const getSceneList = (networkDeviceId) => {
    return dispatch => {
        pxmModbusService.getScenes(networkDeviceId)
            .then(
                (scenesModel) => {
                    dispatch({type: pxmModbusConstants.PXM_MODBUS_LIST_SUCCESS, scenesModel})
                },
                (error) => {
                    dispatch({type: pxmModbusConstants.PXM_MODBUS_LIST_FAILURE, error})
                }
            )
    }
};

const getSceneById = (sceneId) => {
    return dispatch => {
        pxmModbusService.getSceneById(sceneId)
            .then(
                (sceneModel) => {
                    dispatch({type: pxmModbusConstants.PXM_MODBUS_BY_ID_SUCCESS, sceneModel})
                },
                (error) => {
                    dispatch({type: pxmModbusConstants.PXM_MODBUS_BY_ID_FAILURE, error})
                }
            )
    }
}

const createScene = (sceneModel) => {
    return dispatch => {
        pxmModbusService.createScene(sceneModel)
            .then(
                (res) => {
                    dispatch(getSceneList(res.networkDeviceId))
                    dispatch(modalActions.hideModal())
                },
                (error) => {
                    console.log("errorValidation: " + error)
                }
            )
    }
}

const editScene = (sceneModel) => {
    return dispatch => {
        pxmModbusService.updateScene(sceneModel, sceneModel.id)
            .then(
                (res) => {
                    dispatch(getSceneList(res.networkDeviceId))
                    dispatch(modalActions.hideModal())
                },
                (error) => {
                    console.log("errorValidation: " + error)
                }
            )
    }
}

const deleteScene = (sceneId, networkDeviceId) => {
    return dispatch => {
        pxmModbusService.deleteScene(sceneId)
            .then(
                (res) => {
                    dispatch(getSceneList(networkDeviceId))
                    dispatch(modalActions.hideModal())
                },
                (error) => {
                    console.log("errorValidation: " + error)
                }
            )
    }
}

export const pxmModbusActions = {
    getSceneList,
    getSceneById,
    createScene,
    editScene,
    deleteScene
};
